export const getClosestCoordinateByStep = (value: number, step: number) => {
  const remainder = value % step;
  const lowerBound = value - remainder;
  const upperBound = lowerBound + step;

  if (Math.abs(value - lowerBound) <= Math.abs(value - upperBound)) {
    return lowerBound;
  }

  return upperBound;
};